import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "font-awesome/css/font-awesome.min.css";
import { PersistGate } from "redux-persist/lib/integration/react";
import store, { persistor } from "./store";
import { Provider } from "react-redux";
import "swiper/css/bundle";
import "bootstrap/dist/css/bootstrap.min.css";

import "swiper/css";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
